import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { walletDtoUpdateReceivedAction } from '@root/entities/wallet'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { apiRequest } from '@root/shared/api'
import { reatomRequest } from '@root/shared/lib'
import { showSnackbarAction } from '@root/shared/ui-kit'

import type { WalletModel } from '@root/entities/wallet'
import type { EditWalletReqDto } from '@root/shared/api/WalletApi'

export const editWalletRequestAction = action(
  async (ctx, req: EditWalletReqDto) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.wallet.walletEditWalletCreate, [req]),
    )

    if (Result.isSuccess(result)) {
      walletDtoUpdateReceivedAction(ctx, result.success)
    }

    return result
  },
  'editWalletRequestAction',
)

export const reatomEditWallet = ({ wallet }: { wallet: WalletModel }) => {
  const requestState = reatomRequest({
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: `reatomEditWallet_${wallet.id}`,
    execAction: editWalletRequestAction,
    prepare: (_, args: EditWalletReqDto['parameters']) => {
      return { walletId: wallet.id, parameters: args }
    },
    onResult: (ctx, result) => {
      if (Result.isSuccess(result)) {
        showSnackbarAction(ctx, {
          text: i18next.t('wallet.updated_success', {
            wallet: result.success.name,
          }),
          intent: 'success',
        })
      } else {
        showSnackbarAction(ctx, {
          text: i18next.t('wallet.updated_error', {
            wallet: wallet.name,
          }),
          intent: 'error',
        })
      }
    },
  })

  return requestState
}
